import { AppState } from '../../bootstrap/redux/state/AppState';
import { ISiteNameSansId } from '../serverApi/types/ISiteNameSansId';
import { ISitesAndTenantsInfo } from '../serverApi/types/ISitesAndTenantsInfo';


export function selectSites(state: AppState): ReadonlyArray<ISiteNameSansId> {
  return state.sites;
}

export function selectSitesAndTenantsInfo(state: AppState): ISitesAndTenantsInfo {
  return state.sitesAndTenantsInfo;
}
